<template>
  <section>
    <vertical-toggle>
      <div v-show="!isAgree && !$isMicroApp" class="cookie-terms-icas">
        <div class="cookie-wrap">
          <div class="cookie-item font14 cookie-content">
            <span>{{ $t('cookies.tip1') }}</span>
            <span class="cookie-color" @click="showTerms">{{ $t('cookies.tip2') }}</span>
            <span>{{ $t('cookies.tip3') }}</span>
            <span class="cookie-color" @click="showTerms">{{ $t('cookies.tip4') }}</span>
            <span>{{ $t('cookies.tip5') }}</span>
          </div>
          <div>
            <el-button round size="mini" class="cookie-btn cookie" @click="agree(true)">{{ $t('cookies.agree') }}</el-button>
            <el-button round size="mini" class="cookie-btn" @click="agree(false)">{{ $t('cookies.disAgree') }}</el-button>
            <el-button round size="mini" class="cookie-btn" @click="showTerms">{{ $t('cookies.preferenceCenter') }}</el-button>
          </div>
        </div>
        <!-- <el-button class="close" type="text" icon="el-icon-close" @click="close" /> -->
      </div>
    </vertical-toggle>
  </section>
</template>

<script>
import Cookies from 'js-cookie'
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { scrollTo } from '@/utils/scroll-to'
import { onlySaveNecessityCookie, removeOptionCookie } from '@/utils/cookieOperation'
import { getLatestTermRichTextApi } from '@/api/common/public'
import { isOS } from '../../utils/constant'
export default {
  name: 'CookieTerms',
  data() {
    return {
      isAgree: this.$store.getters.cookie_agree.agree,
      id: this.$store.getters.cookie_agree.id,
      orderAgree: {},
      isGetting: false
    }
  },
  computed: {
    ...mapGetters(['uiConfig', 'siteConfig']),
    cookieKey() {
      return this.uiConfig.cookieKey || 1
    },
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
      // if (to !== from) {
        // 获取到的cookie是字符串
        let cookieType = {
          agree: false,
          optimisation: false,
          analytics: false,
          id: ''
        }
        if (Cookies.get('option.preference')) {
          cookieType = JSON.parse(Cookies.get('option.preference'))
          this.orderAgree = cookieType
        }
        this.isAgree = cookieType.agree
        if (isOS()) {
          this.id = cookieType[`id_${this.cookieKey}`] || cookieType.id
        } else {
          this.id = cookieType.id
        }
      }
      this.getLastCookieTerm()
    },
    '$store.getters.cookie_agree.agree'(n, o) {
      if (n) {
        this.isAgree = true
      }
      // console.log('111')
    }
  },
  mounted() {
    if (!this.isAgree) {
      scrollTo(0, 500)
    }
  },

  methods: {
    ...mapMutations({
      setCookieTerms: 'app/SET_COOKIE_TERMS',
      setDefaultCookieId: 'app/setDefaultCookieId'
    }),
    ...mapActions({
      setAgreeCookie: 'app/setAgreeCookie'
    }),
    showTerms() {
      this.setCookieTerms({
        title: this.$t('cookies.cookie'),
        show: true,
        type: this.cookieKey
      })
    },
    async getLastCookieTerm() {
      if (this.isGetting) return

      this.isGetting = true
      try {
        let oldId = ''
        const params = {
          type: this.cookieKey,
          lang: ''
        }
        if (this.id && this.id.toString().indexOf('/') > -1) {
          const arr = this.id.split('/')
          params.lang = arr[0]
          oldId = arr[1]
        }
        const res = await getLatestTermRichTextApi(params, true)
        if (this.isAgree) {
        // 如果cookie 有更新
          if (res.data.id.toString() !== oldId) {
            this.isAgree = false
            if (!isOS()) {
              onlySaveNecessityCookie()
              removeOptionCookie()
            }

            this.id = `${res.data.lang}/${res.data.id}`
          }
        } else {
          this.id = `${res.data.lang}/${res.data.id}`
        }
        if (isOS()) {
          this.setDefaultCookieId(this.id)
        }
      } catch (error) {
        console.log('%c Line:102 🍢', 'color:#3f7cff', error)
      }
    },
    agree(val) {
      this.isAgree = true
      let cookieObj = {
        agree: false,
        optimisation: false,
        analytics: false,
        id: this.id
      }
      if (isOS()) {
        cookieObj = {
          agree: false,
          optimisation: false,
          analytics: false,
          id: this.id,
          [`id_${this.cookieKey}`]: this.id
        }
        try {
          cookieObj = Object.assign(this.orderAgree, cookieObj)
          console.log('%c Line:108 🍫 cookieObj', 'color:#7f2b82', cookieObj)
        } catch (error) {
          console.log(error)
        }
      }
      console.log('%c Line:108 🍫 cookieObj', 'color:#7f2b82', cookieObj)
      if (val) {
        cookieObj.agree = true
        cookieObj.optimisation = true
        cookieObj.analytics = true
        // 重新设置cookie
        this.setAgreeCookie(JSON.stringify(cookieObj))
        location.reload()
      } else {
        // 点击拒绝按钮删除非必要cookie
        onlySaveNecessityCookie()
        removeOptionCookie()
      }
    }
    // close() {
    //   this.isAgree = true
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.cookie-terms-icas{
  position: relative;
  z-index: 9;
  width: 100%;
  padding-top: 32px;
  padding-bottom: 32px;
  background: $color12;
  font-size: 14px;
  font-weight: bold;
  color:$color02;
  .cookie-wrap{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
    .cookie-content{
      width: 560px;
      line-height: 18px;
      .cookie-color{
        color: $color10;
        text-decoration: underline;
        cursor: pointer;
      }
    }
    .cookie-btn{
      margin-left: 0;
      margin-right: 20px;
      padding: 9px 27px;
    }
    .cookie{
      margin-left: 80px;
    }
  }
  .close{
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
    font-size: 22px;
    color: $color02;
    &:hover,&:focus{
      color: $bgHighlight;
    }
  }
}
@media screen and (max-width: 1050px) {
  .cookie{
    margin-left: 30px !important;
  }
}
</style>
